import { YakurekiDetail } from '@/shared/types/yakurekiCore'
import { DrugInfo } from '@/shared/types/yakurekiPrescription'

/**
 * 薬歴詳細データから医薬品リストを抽出する
 * 重複を除いたユニークな医薬品名の配列を返す
 */
export const extractMedicationList = (
  yakurekiDetail: YakurekiDetail | undefined
): string[] => {
  if (!yakurekiDetail?.current_prescription_data?.prescription_groups) {
    return []
  }

  // Setを使って重複を自動的に除去
  const medicationSet = new Set<string>(
    yakurekiDetail.current_prescription_data.prescription_groups
      .flatMap((group) => group.drugs)
      .map((drug: DrugInfo) => drug.drug_name)
      .filter((name: string) => name && name.trim() !== '') // 空文字を除外
  )

  return Array.from(medicationSet).sort() // アルファベット順にソート
}
